export { default } from './EventCardInteractionWrapper';
